import axios from 'axios';
import get from 'lodash.get';

import { LocationCheckErrorType, type LocationCheckError } from '~/utils/geocomply';

import { getApiErrorCode } from '../../utils/utils';

const LOCATION_TOKEN_ERROR_CODES = [
  'LOCATION_TOKEN_REQUIRED',
  'LOCATION_TOKEN_INVALID',
  'LOCATION_TOKEN_CONFLICT',
];

type WithdrawalLocationPrompt = 'permission' | 'recheck';

const isLocationCheckErrors = (error: unknown): error is LocationCheckError[] =>
  Array.isArray(error) &&
  error.length > 0 &&
  error.every((item) => typeof get(item, 'description') === 'string');

export const getWithdrawalLocationPrompt = (error: unknown): WithdrawalLocationPrompt | null => {
  if (isLocationCheckErrors(error)) {
    return error.some((item) => item.type === LocationCheckErrorType.PERMISSION_REQUIRED)
      ? 'permission'
      : 'recheck';
  }

  if (axios.isAxiosError(error) && LOCATION_TOKEN_ERROR_CODES.includes(getApiErrorCode(error))) {
    return 'recheck';
  }

  return null;
};
